/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutPaymentInstrumentViewProps, ICheckoutPaymentOverlayModal } from '@msdyn365-commerce-modules/checkout';
import { ICheckoutPaymentInstrumentProps } from '../definition-extensions/checkout-payment-instrument.ext.props.autogenerated';
import { ICheckoutPaymentInstrumentData } from '../../../dataTypes/checkout-payment-instrument.data';

const OverlayModal: React.FC<ICheckoutPaymentOverlayModal> = ({ modal }) => {
    return <Node {...modal} />;
};

const CheckoutPaymentInstrumentView: React.FC<ICheckoutPaymentInstrumentViewProps &
    ICheckoutPaymentInstrumentProps<ICheckoutPaymentInstrumentData>> = props => {
    const {
        checkoutPaymentInstrument,
        checkoutErrorRef,
        waiting,
        alert,
        paymentInformation,
        addPaymentForm,
        overlayModal,
        data: { customerInformation }
    } = props;
    if (props.data.getPaymentState.result?.isCreditCardSelected && customerInformation.result?.AllowOnAccountPayment) {
        return (
            <Module {...checkoutPaymentInstrument} ref={checkoutErrorRef}>
                {waiting}
                {alert}
                {paymentInformation}
                {addPaymentForm}
                {overlayModal && <OverlayModal {...overlayModal} />}
            </Module>
        );
    } else if (customerInformation.result?.AllowOnAccountPayment === false) {
        return (
            <Module {...checkoutPaymentInstrument} ref={checkoutErrorRef}>
                {waiting}
                {alert}
                {paymentInformation}
                {addPaymentForm}
                {overlayModal && <OverlayModal {...overlayModal} />}
            </Module>
        );
    }
    return null;
};

export default CheckoutPaymentInstrumentView;
